import { useCallback, useEffect } from 'react';
import { TINT_COLOR_UPDATED_EVENT } from '../constants';
import { TTintColor } from '../types';

type TParams = {
  handleSelectColor: (color: Required<TTintColor>) => void;
  handleDeleteColor: () => void;
  isTintServiceAvailable: boolean;
  setIsTintServiceAvailable: (isAvailable: boolean) => void;
};

export const useTintColorUpdated = ({
  handleSelectColor,
  handleDeleteColor,
  isTintServiceAvailable,
  setIsTintServiceAvailable,
}: TParams) => {
  const onUpdatedEvent = useCallback(
    (e: Event) => {
      if (!isTintServiceAvailable) {
        setIsTintServiceAvailable(true);
      }
      if ((e as CustomEvent).detail !== null) {
        handleSelectColor((e as CustomEvent).detail);
      } else {
        handleDeleteColor();
      }
    },
    [handleDeleteColor, handleSelectColor, isTintServiceAvailable, setIsTintServiceAvailable],
  );

  useEffect(() => {
    document.body.addEventListener(TINT_COLOR_UPDATED_EVENT, onUpdatedEvent);

    return () => {
      document.body.removeEventListener(TINT_COLOR_UPDATED_EVENT, onUpdatedEvent);
    };
  }, [onUpdatedEvent]);
};
